import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const applinksAdministrationListRoute: InvariantJiraRoute = {
	name: 'global-settings-products-applinks-administration-list',
	path: '/jira/settings/applinks',
	exact: true,
};
